import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import loginReducer from '../features/login/login-slice';
import ebpcReducer from '../features/evidence-based-practice-changes/ebpc-slice';
import searchReducer from '../features/search/search-slice';
import userFavoriteContentReducer from '../features/favorites-content/skills-favorite-tab/skills-favorite-tab-slice';
import appConfigReducer from '../features/app-config/app-config-slice';
import homeReducer from '../features/home/home-slice';
import myLearningReducer from '../features/home/components/my-learning-card/my-learning-card-slice';
import navigationReducer from '../components/back-button/back-button-slice';
import referentialIPAccessReducer from '../features/referential-access/referential-access-slice';
import emailReducer from '../components/email-modal/email-slice';
import skillLaunchReducer from '../components/skill-launch/skill-launch-slice';
import organizationsReducer from '../features/organizations/organizations-slice';
import selfEnrollmentReducer from '../features/search/self-enrollment/self-enrollment-slice';

const store = configureStore({
    reducer: {
        login: loginReducer,
        ebpcSkills: ebpcReducer,
        homeContent: homeReducer,
        userFavoriteContent: userFavoriteContentReducer,
        myLearning: myLearningReducer,
        appConfigs: appConfigReducer,
        searchContent: searchReducer,
        referentialAccess: referentialIPAccessReducer,
        navigation: navigationReducer,
        emails: emailReducer,
        skillLaunch: skillLaunchReducer,
        selfEnrollment: selfEnrollmentReducer,
        organizations: organizationsReducer,
    },
});

export type IAppDispatch = typeof store.dispatch;
export type IRootState = ReturnType<typeof store.getState>;
export type IAppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    IRootState,
    unknown,
    Action<string>
>;

export default store;
// The store now has redux-thunk added and the Redux DevTools Extension is turned on
